import exp from "constants";

export interface UserInfo {
  stu_name?: string;
  area_name?: string;
  year?: number;
  grade?: number;
}

export interface SubjectInfo {
  subject_id?: number;
  subject_name: string;
  full_score: number;
  improve_score?: number; //提升空间
  is_main_attack?: boolean; //是否为主攻科目
  score: number;
  target_score?: number; //新加目标分数，improve_score + score
}
export interface CollegeRecommend {
  copywriting: string; //后端定义字段如此
  shock: string; //冲
  stable: string; // 稳
  pocket: string; //保
}

export type TotalType = {
  score: number;
  full_score: number;
  improve_score: number;
};

export enum Recommend {
  SHOCK = "shock", //冲
  STABLE = "stable", //稳
  POCKET = "pocket", // 保
}

export type CollegeRecommendParams = {
  edited_subject_info: Array<SubjectInfo>;
  cur_college_recommend?: CollegeRecommend;
  target_college_recommend?: CollegeRecommend;
  sn: string;
};
export enum PostMessageEvent {
  CANCEL= 'cancel',
  OK = 'ok'
}
